import React from "react";
import { Route, Switch } from "react-router-dom";
import featherIcons from "./featherIcons";
import flagIcons from "./flagIcons";
import fontAwsomeIcon from "./fontAwsomeIcon";
import icoIcons from "./icoIcons";
import themifyIcons from "./themifyIcons";
import weatherIcons from "./weatherIcons";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/featherIcons`} component={featherIcons} />
      <Route path={`${match.url}/flagIcons`} component={flagIcons} />
      <Route path={`${match.url}/fontAwsomeIcon`} component={fontAwsomeIcon} />
      <Route path={`${match.url}/icoIcons`} component={icoIcons} />
      <Route path={`${match.url}/themifyIcons`} component={themifyIcons} />
      <Route path={`${match.url}/weatherIcons`} component={weatherIcons} />
    </Switch>
  );
};

export default Production;
